export const sanityResourceNotFound = {
  cta: "Return to library",
  heading: "Whoops",
  metaTitle: "{{type}} Not Found",
  subheading: "No {{type}} was found at this URL",
};
